import course from './course';
import elective from './elective';
import report from './report';

export default {
  path: '/learning-center',
  component: () => import(/* webpackChunkName: "learning" */ '@/views/learning/LearningCenter.vue'),
  children: [
    {
      path: '',
      redirect: 'elective',
    },
    ...course,
    ...elective,
    ...report,
  ],
};
